import React from "react";

const RoomAnywhereAbstract = () => {
  return (
    <div className="p-6 bg-gray-600 text-white mt-4">
      <h1 className="text-xl font-bold text-center text-yellow-200 mb-6">
        RoomAnywhere Abstract
      </h1>
      <p className="text-m text-white mb-4">
        The "RoomAnywhere" is a portable, modular structure designed for
        humanitarian, domestic, and commercial use. It offers quick deployment
        for emergency shelter, providing stable living spaces for the homeless,
        while also serving as adaptable, private rooms within homes, offices,
        and commercial spaces. With its focus on structural versatility,
        eco-friendly design, and community empowerment, RoomAnywhere improves
        living conditions and contributes positively to various environments.
      </p>
      <h2 className="text-lg font-semibold text-yellow-200 mb-4">
        RoomAnywhere in Humanitarian Architecture and Privacy Solutions
      </h2>
      <ul className="space-y-4">
        <li className="p-4 border rounded-lg bg-white shadow-sm">
          <h3 className="text-lg font-medium text-blue-600">Emergency Shelter</h3>
          <p className="text-gray-600">
            Quickly deployable in disaster zones, refugee camps, or public
            health crises, providing lightweight, durable shelters.
          </p>
        </li>
        <li className="p-4 border rounded-lg bg-white shadow-sm">
          <h3 className="text-lg font-medium text-blue-600">
            Privacy in Shared Spaces
          </h3>
          <p className="text-gray-600">
            Customizable partitions create private zones in crowded settings,
            enhancing psychological well-being.
          </p>
        </li>
        <li className="p-4 border rounded-lg bg-white shadow-sm">
          <h3 className="text-lg font-medium text-blue-600">Versatility</h3>
          <p className="text-gray-600">
            Functions as temporary clinics, classrooms, or storage units for
            essential supplies.
          </p>
        </li>
        <li className="p-4 border rounded-lg bg-white shadow-sm">
          <h3 className="text-lg font-medium text-blue-600">Sustainability</h3>
          <p className="text-gray-600">
            Made from durable materials like steel or PVC, with minimal waste
            and maximum adaptability.
          </p>
        </li>
        <li className="p-4 border rounded-lg bg-white shadow-sm">
          <h3 className="text-lg font-medium text-blue-600">Dignified Living</h3>
          <p className="text-gray-600">
            Provides private, personalized spaces, fostering normalcy and
            respect in temporary living conditions.
          </p>
        </li>
        <li className="p-4 border rounded-lg bg-white shadow-sm">
          <h3 className="text-lg font-medium text-blue-600">
            Vertical Farming & Crop Protection
          </h3>
          <p className="text-gray-600">
            Multipurpose use in farming, offering innovative applications in
            vertical farming and crop protection.
          </p>
        </li>
      </ul>
      <p className="text-m text-white mt-6">
        RoomAnywhere combines functionality with dignity, addressing critical
        gaps in emergency and transitional housing.
      </p>
    </div>
  );
};

export default RoomAnywhereAbstract;
